import React from 'react'
import PropTypes from 'prop-types'

import IntroductoryIcon from '../../../assets/codicons/introductory'
import BeginnerIcon from '../../../assets/codicons/beginner'
import ModerateIcon from '../../../assets/codicons/moderate'
import IntermediateIcon from '../../../assets/codicons/intermediate'
import AdvancedIcon from '../../../assets/codicons/advanced'
import PlayIcon from '../../../assets/codicons/play-80'

const AccessedItemImage = (props) => {
  const renderPlaylistImage = () => {
    let image
    if (props.item.coverPhoto) {
      image = <img src={props.item.coverPhoto} />
    } else {
      image = (
        <img src='https://d28gwrkukqy4h7.cloudfront.net/playlists/playlist-default.png' />
      )
    }
    return <div className='entry-image entry-square-image'>{image}</div>
  }

  const renderImage = () => {
    if (props.item.type !== 'playlist') {
      let planEntryMeta
      if (props.item.type === 'class' && props.includeMetaInfo) {
        planEntryMeta = (
          <div className='plan-entry-meta'>
            <div className='entry-difficulty'>
              {difficultyIcon()}
              <span>{props.item.meta.difficulty}</span>
            </div>
            <div className='entry-duration'>
              {props.item.meta.humanDuration}
            </div>
          </div>
        )
      }

      let playIcon
      if (props.item.type === 'class') {
        playIcon = <PlayIcon />
      }
      return (
        <div className='tile-cover-photo'>
          <img src={props.item.coverPhoto} />
          {playIcon}
          {planEntryMeta}
        </div>
      )
    } else {
      return (
        <div className='top-entry-images single-image'>
          <div className='images'>{renderPlaylistImage()}</div>
        </div>
      )
    }
  }

  const difficultyIcon = () => {
    switch (props.item.meta.difficulty) {
      case 'introductory':
        return <IntroductoryIcon />
      case 'beginner':
        return <BeginnerIcon />
      case 'moderate':
        return <ModerateIcon />
      case 'intermediate':
        return <IntermediateIcon />
      case 'advanced':
        return <AdvancedIcon />
    }
  }

  return <a href={props.item.link}>{renderImage()}</a>
}

AccessedItemImage.defaultProps = {
  includeMetaInfo: true
}

AccessedItemImage.propTypes = {
  includeMetaInfo: PropTypes.bool,
  item: PropTypes.object
}

export default AccessedItemImage
